export default function fileUpload(formId:string) {
    type ImageData = {
      src: string;
      file: File;
    };

    const form = document.getElementById(formId);
    if (form) {
      form.addEventListener('reset', (event) => {
        const fileInput = (event.target as HTMLElement).querySelector('[x-data] input[type="file"]') as HTMLInputElement;
        if (fileInput) {
          fileInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    return {
      images: [] as ImageData[],
      onChange(event: Event) {
        event.preventDefault();

        const self = this;
        const fileInput = event.target as HTMLInputElement;
        const dt = new DataTransfer();

        if (fileInput.files && fileInput.files.length > 0) {
          // loading up old files
          const names = [] as string[];
          this.images.forEach((item) => {
            const { file } = (item);
            dt.items.add(file);
            names.push(file.name);
          });

          // loading up not loaded files from the new list
          const newFiles = [...fileInput.files];
          newFiles.forEach((file) => {
            if (!names.includes(file.name)) {
              dt.items.add(file);

              const reader = new FileReader();
              reader.onloadend = () => {
                self.images.push({
                  src: reader.result as string,
                  file,
                });
              };
              reader.readAsDataURL(file);
            }
          });
        } else {
          this.images = [] as ImageData[];
        }

        fileInput.files = dt.files;
      },
      deleteFile(event: Event, name: string) {
        const input = (event.target as HTMLElement).closest('.file-upload-wrap')?.querySelector('input[type="file"]');
        if (input) {
          const dt = new DataTransfer();
          const fileInput = input as HTMLInputElement;

          const newImageList = [] as ImageData[];
          if (this.images && this.images.length > 0) {
            this.images.forEach((item) => {
              const { file } = (item);
              if (file.name !== name) {
                newImageList.push((item));
                dt.items.add(file);
              }
            });
            this.images = newImageList;
            fileInput.files = dt.files;
          }
        }
      },
    };
}
